module.exports = __webpack_public_path__ + "img/user.97d56837.png";